export type ProgressProps = {
  percent: number;
  style?: React.CSSProperties;
  barStyle?: React.CSSProperties;
};

const Progress = ({ percent, style, barStyle }: ProgressProps) => {
  return (
    <div className="w-full rounded-full" style={style}>
      <div
        className={`rounded-full text-xs font-medium text-center leading-none`}
        style={{ height: '6px', ...barStyle, width: `${percent}%` }}></div>
    </div>
  );
};

export default Progress;
